// Based on the documentation received from tinuiti:
// https://drive.google.com/file/d/18Z5k6iUXflsA8hEZBhq-ot4K07NIjEF_/view
import { __decorate } from "tslib";
import { _filterEmptyValues, _Memo } from '@naturalcycles/js-lib';
import { cookieService } from '../../../cookie.service';
import { utmService } from '../../../utm.service';
import { tinuitiPixel } from './tinuiti.pixel';
class TinuitiClient {
    constructor() {
        this.pixelId = 'N/A';
    }
    load() {
        tinuitiPixel();
    }
    pageView({ id }) {
        sendConversionEvent({
            id,
            kpi: 'visit',
            url: globalThis.window.location.href,
        });
    }
    lead({ id }) {
        sendConversionEvent({
            id,
            kpi: 'lead',
        });
    }
    addToCart({ id, amount, currency, plan }) {
        sendConversionEvent({
            id,
            kpi: 'cartadd',
            plan,
            order_value: `${amount}${currency}`,
        });
    }
    purchase({ id, amount, currency, plan, hashedEmail }) {
        sendConversionEvent({
            id,
            kpi: 'purchase',
            user_id: hashedEmail,
            order_value: `${amount}${currency}`,
            plan,
        });
    }
}
__decorate([
    _Memo()
], TinuitiClient.prototype, "load", null);
export const tinuitiClient = new TinuitiClient();
function sendConversionEvent(eventParams) {
    if (typeof process !== 'undefined' && process.env?.['NODE_ENV'] === 'test')
        return;
    let utms = {};
    try {
        utms = utmService.getCookieUtms();
    }
    catch (err) {
        // Suppressing error here since consumers are expected to regularly trigger utcService.refresh() method and
        // propagate corrupt utc cookies issues to sentry
        console.warn('Error parsing utms cookie for tinuiti', err);
    }
    const params = {
        tag_id: 325,
        fpc: cookieService.getCookie('fpc'),
        c: 'naturalcycles',
        ...utms,
        ...eventParams,
    };
    const searchParams = new URLSearchParams(_filterEmptyValues(params)).toString();
    const pixelUrl = `https://pixel.pointmediatracker.com/kpi?${searchParams}`;
    const img = new Image();
    img.src = pixelUrl;
}
